import React, { useEffect } from "react";

import FadeScroller from "components/fade-scroller";
import Heading from "components/heading";

import HeroSection from "../../../hero-section";
import SalesQualificationHeroSVG from "./hero-svg";

const title = "Optimize Your Sales Process with Enerflo Sales Qualification Integrations";

const MainHero = () => {
  useEffect(() => {
    // Scroll to center the highlighed hexagon
    const activeStepImagePath = document.getElementById("integrations-lead-to-pto-active-stage");
    if (activeStepImagePath) {
      activeStepImagePath.scrollIntoView({ block: "nearest", inline: "center" });
    }
  }, []);

  return (
    <HeroSection title={title}>
      <div className="w-full flex-grow space-y-6 md:space-y-10">
        <HeroSection.Content className="mx-auto md:text-center">
          <HeroSection.Header>
            <Heading tag="h1" size="h2">
              {title}
            </Heading>
          </HeroSection.Header>
          <HeroSection.Description>
            Bring your favorite tools for canvassing, lead gen, pipeline management and more. Enerflo syncs all your
            data.
          </HeroSection.Description>
        </HeroSection.Content>

        <div>
          <p className="font-semibold px-6 text-center md:hidden">Enerflo is your Lead-to-PTO Solar Platform</p>

          <FadeScroller>
            <figure className="min-w-[1200px] md:p-3 md:w-full">
              <SalesQualificationHeroSVG />
            </figure>
          </FadeScroller>
        </div>
      </div>
    </HeroSection>
  );
};

export default MainHero;
